export const ALACARTE = 1;
export const BUFFET = 2;
export const BOTH = 3;

export default ({
    1: 'Annosravintola',
    2: 'Linjastoravintola',
    3: 'Annos- ja linjastoravintola'
});



// WEBPACK FOOTER //
// ./resources/assets/js/constants/RestaurantType.js